// extracted by mini-css-extract-plugin
export default {"barcode":"ENeLQPFzVWZmu28UzVfJ"};